module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"step":"Choose an interview template","next":"Next","vacancyCreated":"Job created"}}')
  delete Component.options._Ctor
}
